import { Helmet } from "react-helmet-async";
import { useEffect } from "react";
import { trackPageView } from "@/common/services/analytics";

interface SEOProps {
	title: string;
	description: string;
	name?: string;
	type?: string;
	url?: string;
	image?: string;
}

export default function SEO({
	title,
	description,
	name = "Reel Rewards",
	type = "website",
	url = window.location.href,
	image = "/images/home-page-header.png",
}: SEOProps) {
	const siteUrl = window.location.origin;
	const fullImageUrl = image.startsWith("http") ? image : `${siteUrl}${image}`;

	useEffect(() => {
		trackPageView({
			page_title: title,
			page_location: url,
		});
	}, [title, url]);

	return (
		// @ts-ignore - react-helmet-async types may lag behind React versions.
		<Helmet>
			{/* Standard metadata tags */}
			<title>{title}</title>
			<meta name="description" content={description} />
			<link rel="canonical" href={url} />

			{/* Facebook tags */}
			<meta property="og:type" content={type} />
			<meta property="og:title" content={title} />
			<meta property="og:description" content={description} />
			<meta property="og:image" content={fullImageUrl} />
			<meta property="og:url" content={url} />
			<meta property="og:site_name" content={name} />

			{/* Twitter tags */}
			<meta name="twitter:creator" content={name} />
			<meta name="twitter:card" content="summary_large_image" />
			<meta name="twitter:title" content={title} />
			<meta name="twitter:description" content={description} />
			<meta name="twitter:image" content={fullImageUrl} />
		</Helmet>
	);
}
